import { AffCode } from './affcode.model';

export class AffCodeType {
  public constructor() {
    this.AffCodeTypeID = 0;
    this.AffCodeType = '';
    this.AffCodes = new Array<AffCode>();
    this.Selected = false;
  }
  public AffCodes: Array<AffCode>;
  public AffCodeTypeID: number;
  public AffCodeType: string;
  public Descr: string;
  public AssignedTo: number;
  public Selected: boolean;
}
